<div class="relative" [formGroup]="form" (clickOutside)="isDropdownOpen = false">
  <button class="border border-gray-300 py-2 px-4 flex justify-between items-center w-full h-12 rounded-full"
  (click)="toggleDropdown()"  [disabled]="btnDisabled">
    <input placeholder="--:--" class="max-w-[45px] cursor-pointer pointer-events-none outline-none" [formControlName]="controlName" [id]="controlName + '-time'" [name]="controlName+ 'Time'">
    <i [ngClass]="[isDropdownOpen ? 'icon-chevron-down' : 'icon-chevron-up', btnDisabled ? 'text-gray-300' : 'text-black']"></i>
  </button>
  @if (isDropdownOpen) {
    <div class="w-full absolute top-[100%] left-0 rounded-xlshadow-2xl max-h-[200px] overflow-y-auto overflow-x-hidden py-2 bg-white z-10">
      <ul>
        @for (option of dropdownOptions; track option) {
          <li class="px-4 py-2 hover:bg-primary-50 hover:text-primary-700"
              [ngClass]="{'bg-gray-100 text-primary-700' : option === form.get(controlName)?.value,
              'text-gray-300 cursor-default hover:bg-white hover:text-gray-300': option.isPastHour,
              'cursor-pointer': !option.isPastHour}" (click)="selectTimeSlot(option)">{{option.time}}</li>
        }
      </ul>
    </div>
  }
</div>
